import { connectors } from 'web3modal';
import WalletConnectProvider from '@walletconnect/web3-provider';
//Icons

export const providers = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        1:  'https://rpc-mainnet.maticvigil.com',
        56: 'https://rpc-mainnet.maticvigil.com',
        137: 'https://rpc-mainnet.maticvigil.com'
      },
    },
  },
};


export const mobileProviders = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        1:  'https://rpc-mainnet.maticvigil.com',
        56: 'https://rpc-mainnet.maticvigil.com',
        137: 'https://rpc-mainnet.maticvigil.com'
      },
    },
  },

};
